import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function PremiumBanner() {
  const [showBanner, setShowBanner] = useState(false);

  // Show banner every 1 minute
  useEffect(() => {
    const timer = setInterval(() => {
      setShowBanner(true);
    }, 60000); // 60000 ms = 1 minute

    return () => clearInterval(timer); // Cleanup the interval on component unmount
  }, []);

  // Function to close the banner
  const closeBanner = () => {
    setShowBanner(false);
  };

  return (
    <div className="relative">
      {/* Banner Overlay */}
      {showBanner && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
          <div className="bg-white dark:bg-slate-900 text-center p-8 rounded-md shadow-lg max-w-lg w-full relative">
            {/* Close Button */}
            <button
              onClick={closeBanner}
              className="absolute top-2 right-2  text-2xl font-bold"
            >
              <X />
            </button>
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
              Unlock Premium Plans to Access the Latest Jobs!
            </h2>
            <p className="text-gray-600 dark:text-gray-200 mb-6">
              Don't get stuck with old listings. Upgrade now and explore new job
              opportunities!
            </p>
            <Link
              to="/pricing"
              className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 transition-all duration-300"
            >
              Go to Pricing Page
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
